import { DATE_FILTERS } from './FILTERS';
import { SUB_STRING_CODE } from './CONSTANTS';

/**
 * Web URL for the application.
 * @type {string}
 */
export const BASE_HOTS = 'https://media.gtres.com';

/**
 * Base API URL for the application in localhost.
 * @type {string}
 */
export const BASE_API_URL_LOCAL = '/assets/json';

/**
 * Base API URL for the application.
 *  - Old dev URL: 'https://plugin.gtresonline.com/api';
 *  - Old dev URL: 'https://plugin.gtres.ai/api';
 *  - New dev URL: 'https://media.gtres.com/api';
 *  - Local URL: '/api';
 * @type {string}
 */
export const BASE_API_URL = '/api';

/**
 * Base API AI URL for the application when the AI is enabled.
 * @type {string}
 */
export const BASE_API_AI_URL = '/api/Auth';

/**
 * Collection key for the search results.
 * @type {string}
 */
export const SEARCH_RESULT_COLLECTION_KEY = ':collection';

/**
 * Home slides images API URL.
 * @type {string}
 */
export const HOME_SLIDES_IMAGES = `${BASE_API_URL}/Widgets`;

/**
 * Most wanted API URL.
 * @type {string}
 */
export const MOST_WANTED_URL = `${BASE_API_URL_LOCAL}/most-wanted.json`;

/**
 * Home fixed widgets API URL.
 * @type {string}
 */
export const HOME_FIXED_WIDGETS = `${HOME_SLIDES_IMAGES}/${SEARCH_RESULT_COLLECTION_KEY}`;

/**
 * Endpoint for the authorization code.
 * @type {string}
 */
export const ENDPOINT_AUTH = `${BASE_API_AI_URL}/auth`;

/**
 * Endpoint for the access token.
 * @type {string}
 */
export const ENDPOINT_TOKEN = `${BASE_API_AI_URL}/token`;

/**
 * Endpoint for the user info.
 * @type {string}
 */
export const ENDPOINT_USER_INFO = `${BASE_API_AI_URL}/userinfo`;

/**
 * Endpoint for the user revoke.
 * @type {string}
 */
export const ENDPOINT_REVOKE_USER = `${BASE_API_AI_URL}/revoke`;

/**
 * Endpoint for the search results.
 * @type {string}
 */
export const ENDPOINT_SEARCH_RESULTS = `${BASE_API_URL}/Search`;

/**
 * Endpoint for the search results AI.
 * @type {string}
 */
export const ENDPOINT_SEARCH_RESULTS_AI = `${BASE_API_URL}/AISearch`;

/**
 * Endpoint for the upload image.
 * @type {string}
 */
export const ENDPOINT_UPLOAD_IMAGE = `${ENDPOINT_SEARCH_RESULTS_AI}`;

/**
 * Endpoint for the get image.
 * @type {string}
 */
export const ENDPOINT_GET_IMAGE = `${BASE_API_URL}/Images`;

/**
 * Endpoint for the reports list.
 * @type {string}
 */
export const ENDPOINT_REPORTS_LIST = `${BASE_API_URL}/Features`;

/**
 * Endpoint for the reports details.
 * @type {string}
 */
export const ENDPOINT_GET_REPORT_DETAILS = `${BASE_API_URL}/Features`;

/**
 * Endpoint for the lightbox list.
 * @type {string}
 */
export const ENDPOINT_LIGHTBOX_LIST = `${BASE_API_URL}/LightBoxes`;

/**
 * Endpoint to get the download options of an active.
 * @type {string}
 */
export const ENDPOINT_DOWNLOAD_OPTIONS = `${BASE_API_URL}/Downloads`;

/**
 * Endpoint to get the Cart list state.
 * @type {string}
 */
export const ENDPOINT_CART_LIST = `${BASE_API_URL}/Chart`;

/**
 * Endpoints for the OAuth flow.
 * @type {{
 *  AUTH: string,
 *  TOKEN: string,
 *  USER_INFO: string,
 *  REVOKE_USER: string,
 * }}
 */
export const ENDPOINTS_OAUTH = {
    AUTH: ENDPOINT_AUTH,
    TOKEN: ENDPOINT_TOKEN,
    USER_INFO: ENDPOINT_USER_INFO,
    REVOKE_USER: ENDPOINT_REVOKE_USER,
};

/**
 * OAuth scope.
 * @type {string}
 */
export const OAUTH_SCOPE = 'openid profile';

/**
 * OAuth state.
 * @type {string}
 */
export const OAUTH_STATE = 'xcoiv98y2kd22vusuye3kch';

/**
 * OAuth code key.
 * @type {string}
 */
export const OAUTH_CODE_KEY = 'code';

/**
 * Search image query params.
 * @type {{
 *   TEXT: string,
 *   SEARCH_TEXT: string,
 *   IMAGES: string,
 *   IMAGES_NEG: string,
 *   FACES: string,
 *   FACES_NEG: string,
 *   AI: string,
 *   SORT_BY: string,
 *   SORT_BY_AI: string,
 *   PAGE: string,
 *   PAGE_AI: string,
 *   PAGE_REPORT: string,
 *   PAGE_REPORT_AI: string,
 *   LIMIT: string,
 *   LIMIT_AI: string,
 *   EDITORIAL: string,
 *   CREATIVE: string,
 *   VIDEOS: string,
 *   D_TYPE: string,
 *   REPORTS_TYPE: string,
 *   REPORT_ID: string,
 *   FILTERS: string,
 *   ITEMS: string,
 *   IS_EDITORIAL: string,
 *   SECTION: string,
 *   DATE: string,
 *   DATE_AI: string,
 *   DATE_TO: string,
 *   IMG_UID: string,
 *   PROV: string,
 *   CATEGORIE: string,
 *   COME_FROM_SEARCH: string,
 *   ORIENTATION: string,
 *   PEOPLE: string,
 *   TEMPLATE: string,
 *   GENERATIVE_AI: string,
 *   GENERATIVE_AI_AI: string,
 *   KEYWORDS: string,
 *   CURRENT_TAB: string,
 *   RANGE: string,
 *   FIRST_QUERY: string,
 *   LOAD_PREVIOUS: string,
 *   LOAD_PREVIOUS_PAGE: string,
 *   LOAD_PREVIOUS_LAST_PAGE: string,
 *   RECURSIVE_AI_SEARCH: string,
 *   PREMIUM_IMAGES: string,
 *   AI_SERVER_MAINTENANCE: string,
 *   IS_DETAIL: string,
 * }}
 */
export const SEARCH_IMG_QUERY_PARAMS = {
    TEXT: 'txt',
    SEARCH_TEXT: 'search',
    IMAGES: 'img',
    IMAGES_NEG: 'img_neg',
    FACES: 'face',
    FACES_NEG: 'face_neg',
    AI: 'ai',
    SORT_BY: 'orderby',
    SORT_BY_AI: 'sortby',
    PAGE_AI: 'page',
    PAGE: 'pagenumber',
    PAGE_REPORT_AI: 'page_report_ai',
    PAGE_REPORT: 'page_report',
    LIMIT_AI: 'limit',
    LIMIT: 'pagelength',
    EDITORIAL: 'editorial',
    CREATIVE: 'creative',
    VIDEOS: 'vid',
    D_TYPE: 'dtype',
    REPORTS_TYPE: 'rType',
    REPORT_ID: 'rId',
    FILTERS: 'filters',
    ITEMS: 'items',
    IS_EDITORIAL: 'iseditorial',
    SECTION: 'section',
    DATE: 'dateStart',
    DATE_AI: SUB_STRING_CODE.DAT,
    DATE_TO: 'dateEnd',
    IMG_UID: 'img_uid',
    PROV: 'prov',
    CATEGORIE: 'categorie',
    COME_FROM_SEARCH: 'comeFromSearch',
    ORIENTATION: 'orientation',
    PEOPLE: 'people',
    TEMPLATE: 'template',
    GENERATIVE_AI: 'ai',
    GENERATIVE_AI_AI: 'genAi',
    KEYWORDS: 'keywords',
    CURRENT_TAB: 'currentTab',
    RANGE: 'range',
    FIRST_QUERY: 'firstQuery',
    LOAD_PREVIOUS: 'loadPrevious',
    LOAD_PREVIOUS_PAGE: 'loadPreviousPage',
    LOAD_PREVIOUS_LAST_PAGE: 'loadPreviousLastPage',
    RECURSIVE_AI_SEARCH: 'recursiveAiSearch',
    PREMIUM_IMAGES: 'premium',
    AI_SERVER_MAINTENANCE: 'aiServerMaintenance',
    IS_DETAIL: 'isdetail',
};

/**
 * Provider filters.
 * @type {{
 *  GTRES: string,
 *  PANTHERMEDIA: string,
 * }}
 */
export const PROV_FILTERS = {
    GTRES: 'gtres',
    PANTHERMEDIA: 'panthermedia',
};

/** @type {number} */
export const MAX_RELAUNCH_QUERY_TIMES = 0;

/**
 * Error code for the bad filters search images.
 * @type {number}
 */
export const BAD_FILTERS_SEARCH_IMAGES_CODE = 5000;

/**
 * Error code for the bad image id search images.
 * @type {number}
 */
export const BAD_IMAGE_ID_SEARCH_SIM_IMAGES_CODE = 5001;

/**
 * Error code for the unauthorized request.
 * @type {number}
 */
export const UNAUTHORIZED_WESOG_CODE = 5002;

/**
 * Error code for the lightbox id not found.
 * @type {number}
 */
export const LIGHTBOX_ID_NOT_FOUND_CODE = 5003;

/**
 * Error code for the user not found.
 * @type {number}
 */
export const USER_NOT_FOUND_CODE = 5004;

/**
 * Error code for the bad filters search images with text.
 * @type {number}
 */
export const BAD_FILTERS_SEARCH_IMAGES_WITH_TEXT_CODE = 5005;

/**
 * Error code when the signal is aborted.
 * @type {number}
 */
export const SIGNAL_IS_ABORTED_CODE = 'signal is aborted';

/**
 * Allowed dates filters for the AI search.
 * @type {string[]}
 */
export const ALLOWED_DATE_AI_FILTERS = [
    DATE_FILTERS.LAST_24_HOURS,
    DATE_FILTERS.LAST_7_DAYS,
    DATE_FILTERS.LAST_30_DAYS,
    DATE_FILTERS.LAST_12_MONTHS,
];
